import { useState } from "react";
import { Contact } from "lucide-react";
import { BusinessCardModal } from "./BusinessCardModal";

export function BusinessCardSettingsCard() {
  const [open, setOpen] = useState(false);
  return (
    <section className="panel settings-card" id="settings-business-card" data-testid="settings-business-card">
      <div className="panel-head">
        <div><h2 style={{ display: "flex", alignItems: "center", gap: 7 }}><Contact size={15} /> QR Kartvizit</h2><p>Logonuz, iletişim bilgileriniz ve online teklif QR kodunuzla baskıya hazır kartvizit. Arka yüzde branşlarınız yer alır.</p></div>
        <button type="button" className="primary-button" onClick={() => setOpen(true)} data-testid="settings-open-business-card">Kartviziti aç</button>
      </div>
      {open && <BusinessCardModal onClose={() => setOpen(false)} />}
    </section>
  );
}
